import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@egaranti/components";
import { useTranslation } from "react-i18next";

const FilterSelect = ({
  label,
  value,
  onValueChange,
  placeholder,
  options,
  disabled = false,
  className = "",
}) => {
  const { t } = useTranslation();
  const hasOptions = options && options.length > 0;
  const isDisabled = disabled || !hasOptions;
  const noOptionsText = t(
    "common.noOptions",
    "Seçenek bulunamadı",
  );
  const displayPlaceholder = hasOptions ? placeholder : noOptionsText;

  return (
    <div className={className}>
      <label
        className={`mb-2 block text-sm font-medium ${isDisabled ? "text-[#9CA3AF]" : "text-[#111729]"}`}
      >
        {label}
      </label>
      <Select
        value={value || "all"}
        onValueChange={(val) => onValueChange(val === "all" ? null : val)}
        disabled={isDisabled}
      >
        <SelectTrigger className={isDisabled ? "bg-gray-50 text-gray-400" : ""}>
          <SelectValue placeholder={displayPlaceholder} />
        </SelectTrigger>
        <SelectContent>
          {hasOptions ? (
            options.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))
          ) : (
            <SelectItem value="null" disabled className="text-gray-400">
              {noOptionsText}
            </SelectItem>
          )}
        </SelectContent>
      </Select>
    </div>
  );
};

export default FilterSelect;
